import { useState } from "react";

export const CooldownControl = ({ cooldownSettings, cooldownStatus, loading, onSetCooldown }) => {
    const [cooldownMinutes, setCooldownMinutes] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        await onSetCooldown(cooldownMinutes);
        setCooldownMinutes('');
    };

    return (
        <div className="bg-slate-800 p-3 rounded-lg border border-slate-700">
            <h2 className="text-sm font-semibold text-white mb-2">
                Cooldown Timer
            </h2>

            <form onSubmit={handleSubmit}>
                <div className="mb-1.5">
                    <label className="block text-xs font-medium text-slate-300 mb-1">
                        Cooldown (Minutes)
                    </label>
                    <input 
                        type="number"
                        min="1"
                        step="1"
                        placeholder="Enter cooldown minutes" 
                        value={cooldownMinutes} 
                        onChange={(e) => setCooldownMinutes(e.target.value)}
                        required
                        className="w-full h-8 px-2 text-xs bg-slate-900 text-white border border-slate-700 rounded outline-none focus:border-cyan-500 focus:ring-1 focus:ring-cyan-500"
                    />
                </div>
                
                <button 
                    type="submit"
                    disabled={loading}
                    className={`w-full py-1.5 text-xs font-medium text-white rounded transition-all ${
                        loading 
                            ? 'bg-gray-400 cursor-not-allowed' 
                            : 'bg-cyan-500 hover:bg-cyan-600 cursor-pointer'
                    }`}
                >
                    {loading ? 'Setting...' : 'Set Cooldown'}
                </button>
            </form>

            {cooldownSettings.cooldownMinutes !== null && (
                <div className="mt-2 pt-2 border-t border-slate-700">
                    <div className="flex items-center justify-between text-xs mb-1">
                        <span className="text-slate-400">Setting:</span>
                        <span className="font-semibold text-cyan-400">
                            {cooldownSettings.cooldownMinutes} min
                        </span>
                    </div>
                </div>
            )}

            {cooldownStatus && (
                <div className="mt-2 pt-2 border-t border-slate-700">
                    <div className="flex items-center justify-between text-xs mb-1">
                        <span className="text-slate-400">Status:</span>
                        <span className={`font-semibold ${cooldownStatus.inCooldown ? 'text-orange-400' : 'text-green-400'}`}>
                            {cooldownStatus.inCooldown ? '🔒 In Cooldown' : '✅ Ready'}
                        </span>
                    </div>
                    {cooldownStatus.inCooldown && cooldownStatus.remainingMinutes > 0 && (
                        <div className="flex items-center justify-between text-xs">
                            <span className="text-slate-400">Remaining:</span>
                            <span className="font-semibold text-orange-400">
                                {cooldownStatus.remainingMinutes} min
                            </span>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};
